export default __webpack_public_path__ + "assets/img/ic-edit-name.f3c64dcfdf77bddbaee8219209c8efaa.svg";